import React from 'react';

const AppEnd = ({ focusedTitleRef }) => (
    <div className="mt-5 mb-5">
        <h2 ref={focusedTitleRef} tabIndex={-1}>Bewerbung eingereicht</h2>
        <p>Vielen Dank für Ihre Bewerbung. Wir haben Ihre Unterlagen erhalten und werden Sie in Kürze kontaktieren.</p>
    </div>
);

export default AppEnd;